var regex = /((gt|sm)-|galaxy nexus)|samsung[- ]|samsungbrowser/i;
export function isSamsung(userAgent) {
  return Boolean(userAgent && userAgent.match(regex));
}


//////////////////
// WEBPACK FOOTER
// /home/runner/work/medischeartikelen-website/medischeartikelen-website/node_modules/@algolia/autocomplete-core/dist/esm/utils/isSamsung.js
// module id = 104
// module chunks = 0